import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {fetchFranchises} from "../franchiseSlice";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {showErrorToastNotification, showSuccessToastNotification} from "../../../elements/toastNotification/toastNotificationSlice";
import {FranchiseForm} from "./FranchiseForm";
import {
    clearCreateFranchiseState,
    createFranchise,
    createFranchiseRequestSelector,
    createFranchiseRequestStatusSelector,
    updateCreateFranchiseRequest
} from "../franchiseCreateSlice";

interface Props {
    handleClose: () => void;
}

export const CreateFranchiseForm: React.FC<Props> = ({handleClose}) => {
    const dispatch = useAppDispatch();
    const status = useAppSelector(createFranchiseRequestStatusSelector);

    useEffect(() => {
        dispatch(fetchFranchises());
        return () => {
            dispatch(clearCreateFranchiseState());
        }
    }, [dispatch]);

    useEffect(() => {
        if (status === RequestStatus.RESOLVED) {
            dispatch(fetchFranchises());
            dispatch(showSuccessToastNotification({message: "Franchise Created Successfully"}));
            handleClose();
        } else if (status === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: "Failed to save franchise"}));
        }
    }, [dispatch, handleClose, status]);

    return <FranchiseForm
        title={"Create franchise"}
        onClose={handleClose}
        onSubmit={() => dispatch(createFranchise())}
        requestSelector={createFranchiseRequestSelector}
        updateRequest={updateCreateFranchiseRequest}
    />
}
